export default __webpack_public_path__ + "static/airline-2x-a028960d8108c76fd01870c200856ad6.jpg";